export const defiEs = {
  defiPage: {
    phase: "Fase 5: Marketplace DeFi",
    title: "Tokenización y Finanzas Descentralizadas",
    subtitle: "Invierte en activos agrícolas tokenizados, proporciona liquidez y participa en el staking para obtener rendimientos sostenibles.",
    totalLiquidity: "Liquidez Total Bloqueada",
    volume24h: "Volumen 24h",
    activePools: "Pools Activos",
    averageYield: "Rendimiento Promedio",
    agriculturalTokens: "Tokens Agrícolas",
    liquidityPools: "Pools de Liquidez",
    staking: "Staking",
    price: "Precio",
    marketCap: "Market Cap",
    yieldApy: "Rendimiento APY",
    risk: "Riesgo",
    buy: "Comprar",
    analysis: "Análisis",
    tvl: "TVL",
    rewards: "Recompensas",
    addLiquidity: "Agregar Liquidez",
    stake: "Stake",
    totalStaked: "Total Staked",
    duration: "Duración",
    participants: "participantes"
  }
};